import colors from './colors';
export var palette = {
    text: {
        primary: 'rgba(6, 1, 3, 0.9882)',
        secondary: colors.grey[700],
        disabled: colors.grey[700],
    },
    primary: {
        main: colors.blue[600],
        light: colors.blue[50],
        dark: colors.blue[800],
        contrastText: colors.white,
    },
    secondary: {
        main: colors.darkBlue[500],
        light: colors.darkBlue[50],
        dark: colors.darkBlue[900],
        contrastText: colors.white,
    },
    error: {
        main: colors.orange[900],
        light: colors.orange[50],
        dark: colors.orange.A700,
        contrastText: colors.white,
    },
    common: {
        black: colors.greyscale[100],
        white: colors.white,
    },
    grey: colors.grey,
    action: {
        hover: "rgba(59,214,255, 0.1)",
    },
    success: {
        light: colors.green[50],
        main: colors.green.A400,
        dark: colors.green.A700,
        contrastText: colors.white,
    },
    warning: {
        light: colors.yellow[50],
        main: colors.yellow[500],
        dark: colors.yellow.A700,
        contrastText: colors.white,
    },
};
//# sourceMappingURL=palette.js.map